import { contestsTopicSlug } from 'mk2/apps/contests/constants';
import { contestsHomeUrl } from 'mk2/apps/contests/urls';
import PostDetailPage, {
    OwnProps,
    PostDetailViewType,
    Props,
    RouteProps,
    StateProps,
} from 'mk2/apps/forum/containers/PostDetail/PostDetailPage';
import { AppState } from 'mk2/reducers';
import React from 'react';
import { MapStateToPropsParam } from 'react-redux';

export default class ContestPostDetailPage extends PostDetailPage {

    public mapStateToProps(): MapStateToPropsParam<StateProps, OwnProps & RouteProps, AppState> {
        return (state: AppState, ownProps: OwnProps & RouteProps): StateProps => {
            const props = { ...ownProps };
            props.match.params.topicSlug = contestsTopicSlug;

            return {
                ...super.mapStateToProps()(state, ownProps) as StateProps,
                viewType: PostDetailViewType.Contest,
            };
        };
    }

    public getDefaultBackPath(props: Props): string {
        return contestsHomeUrl;
    }

    public getHeaderRightOnMainFormPage(props: Props): React.ReactElement {
        return null;
    }

}
